export default __webpack_public_path__ + "static/media/mobile_beehive_harvest_status.653ffae0.png";